// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"river-mini-portable-power-station_productcontent__peNUs"};